<template>
  <transition name="fade-in" appear>
    <div style="z-index: 99999" class="modal fade-in" v-show="mostrarModal">
      <div class="modal-content">
        <div class="modal-header">
          <span
            class="close"
            @click="fecharModal()"
            style="position: absolute; top: 10px; right: 10px"
            >&times;</span
          >
          <div class="header-content">
            <h2>Mudança para padrão Mercosul</h2>
          </div>
        </div>
        <div class="modal-body">
          <div class="information-container">
            <p class="infoModal">
              Não foi possível realizar a mudança do padrão da placa no momento!
            </p>
          </div>
        </div>
        <div class="modal-footer">
          <button class="close-button" @click="fecharModal()">Fechar</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      mostrarModal: true,
    };
  },

  mounted() {
    console.log(window.innerWidth, "coprimento da tela");
  },

  methods: {
    fecharModal() {
      const modal = document.querySelector(".modal");
      modal.classList.add("fade-out");
      modal.classList.remove("fade-in");

      modal.addEventListener("animationend", () => {
        this.$emit("fechar");
        this.mostrarModal = false;
      });
    },
  },
};
</script>

<style scoped>
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  margin-top: -135px;
}

.modal-content {
  background-color: #fff;
  width: 646px;
  height: 251px;
  /* padding: 20px; */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  text-align: center;
  border-radius: 10px; /* Adiciona bordas arredondadas à modal */
}

.modal-header {
  border-radius: 6px;
  background: var(--error-light, #e21d12);
  color: white;
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  margin-bottom: 20px;
}

.modal-header h2 {
  margin: 0;
}

.header-content {
  margin-left: 26px;
}

h2 {
  color: #fff;
  font-family: Open Sans;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-align: left;
}

.close {
  font-size: 24px;
  cursor: pointer;
  width: 24px;
  height: 24px;
}
.modal-body {
  padding: 0px;
}

.modal-footer {
  padding: 13px;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  border: none;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.fade-in {
  animation: fadeIn 0.4s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.fade-out {
  animation: fadeOut 0.2s ease;
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.labelContainer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

input {
  width: 132px;
  height: 46px;
  flex-shrink: 0;
  margin-right: 138px; /* Adicione margem entre os inputs */
  margin-left: 60px;
  border-radius: 7.253px;
  border: 1.451px solid #d0d0d0;
  background: #e1e1e1;
  color: #252525;
  font-family: Open Sans;
  font-size: 21.758px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-align: center;
}
label {
  margin-right: 89px;
  margin-left: 62px;
}
.infoModal {
  color: #252525;
  font-family: Open Sans;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.close-button {
  display: flex;
  width: 192px;
  height: 38px;
  padding: 8px 14px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  border-radius: 40px;
  background: #0074c8;
  color: var(--primary-contrast, #fff);
  text-align: center;
  font-family: Open Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  border: #0074c8;
  line-height: normal;
  margin-left: 398px;
  margin-top: 44px;
}
.information-container {
  margin-top: 20px;
}

@media (max-width: 500px) {
  .modal-content {
    width: 396px;
  }

  .close-button {
    margin-left: 3px;
  }

  .infoModal {
    font-size: 15px;
  }
}

@media (max-width: 400px) {
  .modal-content {
    width: 377px;
  }

  .close-button {
    margin-left: 12px;
  }

  .infoModal {
    font-size: 15px;
  }
}

@media (width: 1366px) {
  .modal {
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// modal-error-merc.vue?650c6bff